export const toJson = (XLSX, workbook) => {
  const result = {};
  workbook.SheetNames.forEach(sheetName => {
    const sheet = workbook.Sheets[sheetName];
    const roa = XLSX.utils.sheet_to_json(sheet, { raw: false });
    if (roa.length > 0) result[sheetName] = roa;
  });
  return result;
};

/** Synonyms matched on normalized header cells (see StepRecipientsPicker.parseSpreadsheet). */
export const EXTERNAL_RECIPIENT_HEADER_SYNONYMS = {
  email: ['email', 'correo', 'e-mail', 'mail'],
  firstName: ['firstname', 'first name', 'nombre', 'nom', 'given'],
  lastName: ['surname', 'last name', 'apellido', 'cognom', 'family'],
  fullName: ['full name', 'name', 'nom complet', 'display'],
  phone: ['phone', 'tel', 'mobile', 'mòbil', 'movil'],
  department: ['department', 'dept', 'division', 'area', 'unit', 'área'],
  jobTitle: ['job title', 'jobtitle', 'title', 'position', 'cargo', 'puesto', 'role'],
  code: ['code', 'employee code', 'codigo', 'employee id', 'matricula', 'staff id'],
};

/** Data rows for the downloadable template (sheet “Recipients”). */
export const getExternalRecipientsSampleSheetRows = () => [
  ['email', 'name', 'phone', 'department', 'job title', 'code', 'First name', 'Last name'],
  [
    'recipient@example.com',
    'Jane Doe',
    '+34600000000',
    'Engineering',
    'Developer',
    'E-1001',
    '',
    '',
  ],
  [
    'split-name@example.com',
    '',
    '+34600111222',
    'Sales',
    'Account manager',
    'E-2002',
    'John',
    'Smith',
  ],
];

/** Second sheet: human-readable list of accepted headers (no impact on import). */
export const getExternalRecipientsReferenceSheetRows = () => [
  ['Purpose', 'Accepted column headers (any one per purpose; matching is case-insensitive)'],
  ['Email (required)', 'email, mail, e-mail, correo'],
  ['Full name (optional if using first + last below)', 'name, full name, display, nom complet'],
  ['First name (optional)', 'first name, firstname, given name, nombre, nom, …'],
  ['Last name (optional)', 'last name, surname, apellido, cognom, family, …'],
  ['Phone (optional)', 'phone, tel, mobile, mòbil, movil, …'],
  ['Department (optional)', 'department, dept, division, area, unit, …'],
  ['Job title (optional)', 'job title, title, position, cargo, puesto, …'],
  ['Employee code (optional)', 'code, employee code, codigo, employee id, …'],
  [''],
  [
    'Tip',
    'Use either the full-name column OR First name + Last name for each row—not both styles for the same person.',
  ],
];

/** Builds .xlsx with Recipients + Column reference sheets. */
export const buildExternalRecipientsSampleXlsx = async () => {
  const XLSX = await import('xlsx');
  const wb = XLSX.utils.book_new();
  const wsRecipients = XLSX.utils.aoa_to_sheet(getExternalRecipientsSampleSheetRows());
  const wsRef = XLSX.utils.aoa_to_sheet(getExternalRecipientsReferenceSheetRows());
  XLSX.utils.book_append_sheet(wb, wsRecipients, 'Recipients');
  XLSX.utils.book_append_sheet(wb, wsRef, 'Column reference');
  return XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
};

const rABS =
  typeof FileReader !== 'undefined' &&
  FileReader.prototype &&
  FileReader.prototype.readAsBinaryString;

const fixdata = data => {
  let o = '';
  let l = 0;
  const w = 10240;
  for (; l < data.byteLength / w; ++l)
    o += String.fromCharCode.apply(null, new Uint8Array(data.slice(l * w, l * w + w)));
  o += String.fromCharCode.apply(null, new Uint8Array(data.slice(o.length)));
  return o;
};

export const readXlsxFromFileData = async (fileDataIn, readtype = { type: 'array' }) => {
  let fileData = fileDataIn;
  if (!fileData) {
    return {};
  }
  let arr;
  if (!rABS) {
    arr = fixdata(fileData);
    fileData = btoa(arr);
  }
  const XLSX = await import('xlsx');
  const wb = XLSX.read(fileData, readtype);
  return {
    XLSX,
    wb,
  };
};

export const readXlsxFromFile = file => {
  const reader = new FileReader();
  const readtype = { type: rABS ? 'binary' : 'base64' };
  return new Promise(resolve => {
    reader.onload = e => {
      const fileData = e.target.result;
      const ret = readXlsxFromFileData(fileData, readtype);
      resolve(ret);
    };
    if (rABS) reader.readAsBinaryString(file);
    else reader.readAsArrayBuffer(file);
  });
};
